import { render, staticRenderFns } from "./carFormTabDetail.vue?vue&type=template&id=1e833828&scoped=true&"
import script from "./carFormTabDetail.vue?vue&type=script&lang=js&"
export * from "./carFormTabDetail.vue?vue&type=script&lang=js&"
import style0 from "./carFormTabDetail.vue?vue&type=style&index=0&id=1e833828&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e833828",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e833828')) {
      api.createRecord('1e833828', component.options)
    } else {
      api.reload('1e833828', component.options)
    }
    module.hot.accept("./carFormTabDetail.vue?vue&type=template&id=1e833828&scoped=true&", function () {
      api.rerender('1e833828', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/CarForm/carFormTabDetail.vue"
export default component.exports